export default __webpack_public_path__ + "static/media/empresa1.b4c67777.png";